<template>
  <f7-page
    name="home"
    class="page-home"
  >
    <template #fixed>
      <TheNavbar
        :nav-title="t('common.home')"
        menu-btn-enable
        notifications-erp-btn-enable
      />
    </template>

    <div class="padding-top">
      <TheDashboard />
    </div>
  </f7-page>
</template>

<script setup>
// @ts-check
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useUserUuid } from '@/composables/useUserUuid';
import { useI18n } from 'vue-i18n';
import firebaseAnalytics from '@/js/services/firebase-analytics';
import { IS_DEVELOPMENT } from '@/js/common/constants';

import TheNavbar from '@/components/TheNavbar.vue';
import TheDashboard from '@/components/TheDashboard.vue';

const {
  userLoginData,
  userEnviroment,
} = storeToRefs(useAppConfigStore());

const { userUuid } = useUserUuid();
const { t } = useI18n();

function logToFirebaseAnalytics() {
  if (IS_DEVELOPMENT || !userEnviroment.value || !userLoginData.value) {
    return;
  }

  if (!userUuid.value) {
    throw new Error('Failed to generate UUID');
  }

  firebaseAnalytics.setUserId(userUuid.value);
  firebaseAnalytics.setUserProperties({
    companyID: userEnviroment.value.Instalacion.Codigo,
    companyName: userEnviroment.value.Instalacion.Nombre,
    username: userLoginData.value.UserName,
  });
  firebaseAnalytics.setScreenName('Login');
  firebaseAnalytics.logEvent('Login', { content_type: 'Events', item_id: 'Login' });
}

onMounted(() => {
  logToFirebaseAnalytics();
});
</script>

<style scoped lang="scss">
.page-home {
  --f7-page-bg-color: var(--his-mora-tint);

  .page-content {
    overflow-y: scroll;
  }

  .navbar-inner {
    .right {
      div div {
        margin-top: unset !important;

        span {
          display: flex;
        }
      }
    }
  }
}
</style>
